import axios from 'axios';

const downloadCsv = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'resultados-atual');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const tryExportingWinners = (promoId, sorteioId, setLoading, setErrorExport) => {
    setLoading(true);
    axios
        .get(`${process.env.REACT_APP_API_URL}/admin/cadastros/export?promo_id=${promoId}&sorteio_id=${sorteioId}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('adminAccessToken')}`
            },
        })
        .then((response) => {
            console.log(response)
            downloadCsv(response.data.url);
            setLoading(false);
        })
        .catch((err) => {
            console.log(err)
            setErrorExport(err.response.data.message);
            setLoading(false);
        });
}

export default tryExportingWinners;